import {Component, Input} from '@angular/core';
import {RouterLink} from "@angular/router";


@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    imports: [
    RouterLink
],
    styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent {

  @Input()
  currentRouteName: string;

  @Input()
  previousRoute: { name: string, route: string };

}
